import { toast } from "sonner";
import { logErrorEvent } from "./logger";
import { getUserFriendlyError } from "./translate";
import type { AppError, ErrorContext } from "./types";

export function showAppError(
  error: unknown,
  context: ErrorContext,
  options?: { log?: boolean },
): AppError {
  const appError = getUserFriendlyError(error, context);

  let description = appError.user_message;
  if (appError.user_action) {
    description += `\n${appError.user_action}`;
  }
  if (appError.error_family === "unexpected" && appError.correlation_id) {
    description += `\nRef: ${appError.correlation_id}`;
  }

  switch (appError.severity) {
    case "info":
      toast.info(appError.user_title, { description });
      break;
    case "warning":
      toast.warning(appError.user_title, { description });
      break;
    case "critical":
    case "error":
    default:
      toast.error(appError.user_title, { description });
      break;
  }

  if (options?.log !== false) {
    logErrorEvent(appError).catch(() => undefined);
  }

  return appError;
}
